import React, { useMemo } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import PageHeader from "../../Components/PageHeader";
import getCourseProgress from "../../util/getCourseProgress";
import type { Course } from "../Menu/Menu.types";
import type { CourseData } from "./Education.types";

import styles from "./EducationCoursePageHeader.module.css";

type EducationCoursePageHeaderProps = {
  course: Course;
  userData?: UserData | null;
  courseData?: CourseData | null;
  /** Showroom / nested previews — skip page top inset. */
  embedded?: boolean;
  compact?: boolean;
};

export function formatEducationCourseSubtitle(
  course: Course,
  defaultSubtitle: string,
  progressLabel: string
): string {
  return [course.SubTitle?.trim() || defaultSubtitle, progressLabel].join(
    " · "
  );
}

function EducationCoursePageHeader({
  course,
  userData,
  courseData,
  embedded = false,
  compact = false,
}: EducationCoursePageHeaderProps) {
  const { t } = useTranslation();

  const subtitle = useMemo(() => {
    const progress = getCourseProgress(course, userData, courseData);
    return formatEducationCourseSubtitle(
      course,
      t("educationSnake.pageSubtitle"),
      t("header.progress", { progress })
    );
  }, [course, courseData, t, userData]);

  return (
    <div
      className={clsx(
        styles.header,
        embedded && styles.headerEmbedded,
        compact && styles.headerCompact,
      )}
    >
      <PageHeader
        title={course.Title ?? ""}
        subtitle={subtitle}
        align="center"
        compact={compact}
      />
    </div>
  );
}

export default EducationCoursePageHeader;
